import React, { useState } from 'react';
import { Image } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';

import { listMultiItem } from 'components/banners/DisplayItems';
import { LinkSection } from 'components/base/LinkSection';
import AlertInfoPrompt from 'components/base/prompt/AlertInfoPrompt';
import { getCampaignTypeTitle } from 'components/campaign/campaignCreation/CreateCampaignStepOneConfigs';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import {
  CampaignType,
  DISPLAY_TARGET_CUSTOMER_TYPE,
  EarningRuleRewardType,
  EarningRuleTypeKey,
  LanguageConfig,
  TARGET_CUSTOMER_TYPE,
  WEEKDAY,
} from 'config/CustomEnums';
import {
  isTicketCampaignOtherInformationQuestionShowOption,
  getDisplayRecurringPeriod,
} from 'models/CreateCampaignModel';

import { capitalizeFirstLetter } from 'utils/StringUtil';
import { getReadablePeriod } from 'utils/TimeFormatUtil';

import CheckOnIcon from 'assets/images/check_on.svg';

import './ProfileSection.scss';

function ProfileSection({ data }) {
  const { getValues } = useFormContext() || {};
  const campaign = data || getValues() || {};
  console.log("prifileSections:", campaign)

  const getListStrings = (list, linkPrefix = "", linkText = "View detail") => {
    if (list?.length === 0) {
      return null;
    }
    return (
      <ul>
        {list?.map((item) => (
          <li>
            {`[ID: ${item.pk}] ${item.name}`}
            <LinkSection
              link={linkPrefix ? `${linkPrefix}/${item.pk}/` : null}
              linkText={linkText}
              disableLink={linkPrefix === '/coupons' && item.toDelete}
              disableLinkText="Deleted"
            />
          </li>
        ))}
      </ul>
    );
  };


  const profileField = ({
    field,
    value,
    link = '',
    linkText = 'View detail',
    disableLink = false,
    disableLinkText = 'Deleted',
  }) => {
    return (
      <>
        {field && <CustomTitleLabel title={field} />}
        <div>
          <label className="create-section-field-input profile-section-label-bottom">
            {value || '-'}
          </label>
          <LinkSection
            link={link}
            linkText={linkText}
            disableLink={disableLink}
            disableLinkText={disableLinkText}
          />
        </div>
      </>
    );
  };

  const earningCampaignEarningRuleSection = () => {
    const earningRuleType =
      EarningRuleTypeKey?.[campaign.linkedEarningRules?.type];
    const earningRuleRewardType =
      campaign.linkedEarningRules?.[`${earningRuleType || ''}TypeRewardType`];

    let rewardQuantity;
    if (earningRuleRewardType === EarningRuleRewardType.coupons) {
      rewardQuantity =
        campaign.linkedEarningRules?.[
        `${earningRuleType || ''}TypeCouponRewardTypeQuantity`
        ];
    } else if (earningRuleRewardType === EarningRuleRewardType.points) {
      rewardQuantity =
        campaign.linkedEarningRules?.[
        `${earningRuleType || ''}TypePointsRewardTypePoints`
        ];
    }

    return (
      <>
        {profileField({
          field: 'Link to earning rule set',
          ...(campaign.linkedEarningRules?.pk
            ? {
              value: `[ID: ${campaign.linkedEarningRules.pk}] ${campaign.linkedEarningRules?.name}`,
              link: `/earns/${campaign.linkedEarningRules.pk}/`,
              linkText: 'View earning rule',
            }
            : {
              value: campaign.linkedEarningRules?.name || '-',
            }),
        })}
        {profileField({
          field: 'Reward type',
          value: capitalizeFirstLetter(
            earningRuleRewardType?.toLowerCase() || '-',
          ),
        })}
        {earningRuleRewardType === EarningRuleRewardType.coupons &&
          profileField({
            field: 'Link to coupon set',
            ...(campaign.linkedEarningRules?.[
              `${earningRuleType || ''}TypeCouponRewardTypeCouponTemplate`
            ]?.pk
              ? {
                value:
                  `[ID: ${campaign.linkedEarningRules?.[
                    `${earningRuleType || ''
                    }TypeCouponRewardTypeCouponTemplate`
                  ].pk
                  }]` +
                  ` ${campaign.linkedEarningRules?.[
                    `${earningRuleType || ''
                    }TypeCouponRewardTypeCouponTemplate`
                  ]?.name
                  }`,
                link: `/coupons/${campaign.linkedEarningRules?.[
                  `${earningRuleType || ''
                  }TypeCouponRewardTypeCouponTemplate`
                ].pk
                  }/`,
                linkText: 'Link to coupon set',
                disableLink:
                  campaign.linkedEarningRules?.[
                    `${earningRuleType || ''
                    }TypeCouponRewardTypeCouponTemplate`
                  ]?.toDelete,
              }
              : {
                value:
                  campaign.linkedEarningRules?.[
                    `${earningRuleType || ''
                    }TypeCouponRewardTypeCouponTemplate`
                  ]?.name || '-',
              }),
          })}
        {profileField({
          field: 'Quantity',
          value: rewardQuantity || '-',
        })}
        {earningRuleRewardType === EarningRuleRewardType.points &&
          profileField({
            field: 'Progression points',
            value:
              campaign.linkedEarningRules?.[
              `${earningRuleType || ''}TypePointsRewardTypeTpe`
              ] || '-',
          })}
      </>
    );
  };

  const getCouponsDisplayTotalStock = (couponList) => {
    let totalAcquiredCoupon = 0;
    let totalUsedCoupon = 0;
    let totalStock = 0;
    couponList?.length > 0 &&
      couponList.forEach((coupon) => {
        totalAcquiredCoupon += coupon?.totalNumberOfAcquiredCoupons || 0;
        totalUsedCoupon += coupon?.totalNumberOfUsedCoupons || 0;
        totalStock += coupon?.totalNumberOfGeneratedCoupons || 0;
      });
    return `Acquired/Used/Total Stock: ${totalAcquiredCoupon}/${totalUsedCoupon}/${totalStock}`;
  };

  return (
    <>
      <label className="create-section-title">PROPERTIES</label>
      {profileField({
        field: 'Campaign type',
        value: getCampaignTypeTitle(campaign.campaignType),
      })}
      {campaign.campaignType === CampaignType.ticketCampaign && (
        <>
          {profileField({
            field: 'Enable OTP',
            value: campaign?.enableOtp ? 'Yes' : 'No',
          })}
          <CustomTitleLabel title={'Link to coupon set (ticket type)'} />
          <ul className="first-ul">
            {campaign?.ticketCampaignTimeSlots?.map((item) => (
              <li className="create-section-field-input">
                {profileField({
                  value: `[ID: ${item.couponSet?.pk}] ${item.couponSet?.name}`,
                  link: `/coupons/${item.couponSet.pk}/`,
                  linkText: 'View coupon set',
                  disableLink: item.couponSet.toDelete,
                })}
                <ul className="second-ul">
                  <li
                    className="create-section-field-input"
                    style={{ color: '#979797' }}
                  >
                    {`Acquired/Used/Total Stock: ${item.couponSet?.totalNumberOfAcquiredCoupons || 0
                      }/${item.couponSet?.totalNumberOfUsedCoupons || 0}/${item.couponSet?.totalNumberOfGeneratedCoupons || 0
                      }`}
                  </li>
                </ul>
              </li>
            ))}
          </ul>
          {profileField({
            field: 'Total number of coupon from linked coupon set',
            value: getCouponsDisplayTotalStock(
              campaign?.ticketCampaignTimeSlots?.map((item) => item?.couponSet),
            ),
          })}
          {profileField({
            field: 'Fill other information',
            value: campaign?.fillOtherInfomation ? 'Yes' : 'No',
          })}
          {campaign?.fillOtherInfomation && (
            <TickCampaignQuestionsAndOptionsSection campaign={campaign} />
          )}
        </>
      )}
      {campaign.campaignType === CampaignType.couponsCampaign && (
        <>
          {profileField({
            field: 'Link to coupon set',
            ...(campaign.linkedCoupon?.pk
              ? {
                value: `[ID: ${campaign.linkedCoupon.pk}] ${campaign.linkedCoupon?.name}`,
                link: `/coupons/${campaign.linkedCoupon.pk}/`,
                linkText: 'View coupon set',
                disableLink: campaign.linkedCoupon.toDelete,
              }
              : {
                value: campaign.linkedCoupon?.name || '-',
              }),
          })}
          {profileField({
            field: 'Total number of coupon from linked coupon set',
            value: `Acquired/Used/Total Stock: ${campaign?.linkedCoupon?.totalNumberOfAcquiredCoupons || 0
              }/${campaign?.linkedCoupon?.totalNumberOfUsedCoupons || 0}/${campaign?.linkedCoupon?.totalNumberOfGeneratedCoupons || 0
              }`,
          })}
        </>
      )}
      {campaign.campaignType === CampaignType.earningRulesCampaign &&
        earningCampaignEarningRuleSection()}
      {profileField({
        field: 'Campaign category',
        value: getListStrings(campaign.categories),
      })}
      {profileField({
        field: 'Target customer',
        value: campaign.isExclusive
          ? DISPLAY_TARGET_CUSTOMER_TYPE?.[campaign.generalType] || campaign.generalType
          : null,
      })}
      {profileField({
        field: 'Static segment',
        value: getListStrings(
          campaign.isExclusive && campaign.generalType === TARGET_CUSTOMER_TYPE.STATIC_SEGMENT
            ? campaign.staticSegments
            : [],
          "/segments",
        ),
      })}
      {profileField({
        field: 'Dynamic segment',
        value: getListStrings(
          campaign.isExclusive && campaign.generalType === TARGET_CUSTOMER_TYPE.DYNAMIC_SEGMENT
            ? campaign.dynamicSegments
            : [],
          "/segments",
        ),
      })}
      {profileField({
        field: 'Levels',
        value: getListStrings(
          campaign.isExclusive && campaign.generalType === TARGET_CUSTOMER_TYPE.LEVEL
            ? campaign.levels
            : [],
          "/levels"
        ),
      })}
      {profileField({
        field: "Exclude blacklist segment",
        value: campaign.excludeBlacklistSegment ? "Yes" : "No",
      })}
      {profileField({
        field: 'Blacklist segment',
        value: getListStrings(
          campaign.excludeBlacklistSegment
            ? campaign.blacklistSegments
            : [],
          "/segments",
        ),
      })}
      {profileField({
        field: 'Active period',
        value: getReadablePeriod(
          campaign.activeStartDate,
          campaign.activeEndDate,
          campaign.isAlwaysActivePeriod,
        ),
      })}
      {listMultiItem(
        'Blackout period (by period)',
        campaign.activePeriodValues?.map((item) =>
          getReadablePeriod(item.startDate, item.endDate, false),
        ),
      )}
      {listMultiItem(
        'Blackout period (by weekday)',
        campaign.activeWeekday?.map((item) => WEEKDAY[item]),
      )}
      {profileField({
        field: 'Visible period',
        value: getReadablePeriod(
          campaign.visibleStartDate,
          campaign.visibleEndDate,
          campaign.isAlwaysVisiblePeriod,
        ),
      })}
      {profileField({
        field: 'Related brand',
        value: campaign.linkedBrand?.name,
      })}
      {campaign.campaignType === CampaignType.couponsCampaign && (
        <>
          {/* {profileField({
                field: 'Per campaign coupon acquiring limit',
                value: campaign?.linkedCoupon?.totalNumberOfGeneratedCoupons === null
                  ? '-'
                  : `${campaign?.linkedCoupon?.totalNumberOfGeneratedCoupons} number of coupons`,
              })} */}
          {campaign.displayOverLimit && (
            <div className="display-over-all-limit-container">
              <Image
                src={CheckOnIcon}
                className="display-over-all-limit-icon"
              />
              <label className="display-over-all-limit">
                Display the overall limit in the campaign.
              </label>
            </div>
          )}
          {profileField({
            field:
              'Per head coupon acquiring limit during the campaign active period',
            value:
              campaign.perHeadLimit === null
                ? '-'
                : `${campaign.perHeadLimit} number of coupons`,
          })}
          {profileField({
            field: 'Required points',
            value: `${campaign.requiredPoints} points`,
          })}
        </>
      )}
      {
        profileField({
          field: "This is a recurring campaign for birthday",
          value: campaign.isBirthdayRecurringCampaign ? "Yes" : "No",
        })
      }
      {
        profileField({
          field: "Recurring active period",
          value: getDisplayRecurringPeriod({
            isForBirth: campaign.isBirthdayRecurringCampaign,
            recurringDate: campaign?.recurringDate,
            prefix: "Active"
          })
        })
      }
      {
        profileField({
          field: "Recurring visible period",
          value: getDisplayRecurringPeriod({
            isForBirth: campaign.isBirthdayRecurringCampaign,
            recurringDate: campaign?.recurringDate,
            prefix: "Visible"
          })
        })
      }
    </>
  );
}

const TickCampaignQuestionsAndOptionsSection = ({ campaign }) => {
  const title = 'Questions and options';
  const [showSeeMorePrompt, setShowSeeMorePrompt] = useState(false);

  const customerProfileFields = campaign?.showCustomerProfileFields || [];
  const customerAdditionalFields = campaign?.showCustomerAdditionalFields || [];
  const additionalQuestion = campaign?.additionalQuestion || [];

  const showCustomerAdditionalFields = customerProfileFields?.length <= 5;
  const showAdditionalQuestion =
    customerProfileFields.length + customerAdditionalFields.length <= 5;
  const displayShowMoreButton =
    customerProfileFields.length +
    customerAdditionalFields.length +
    additionalQuestion.length >
    5;

  const diaplayOptitons = (additionalQuestion) => {
    const { fieldFormat, fieldOptions } = additionalQuestion;
    if (
      !isTicketCampaignOtherInformationQuestionShowOption({
        fieldFormat: fieldFormat?.value?.value,
      })
    ) {
      return;
    }
    if (fieldOptions?.length < 1) {
      return;
    }
    return (
      <>
        <ul className="second-ul">
          {fieldOptions.map((option) => (
            <li>{option?.[LanguageConfig.english] || '-'}</li>
          ))}
        </ul>
      </>
    );
  };

  const displayCustomerProfileFieldsList = (showAll = true) => {
    return (
      <>
        {customerProfileFields?.map((field, index) => {
          if (!showAll && index > 4) {
            return <></>;
          }
          return (
            <li className="create-section-field-input">
              {field?.fieldName
                ?.split('_')
                ?.map((word, index) => {
                  return (
                    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                  );
                })
                .join(' ') || '-'}
            </li>
          );
        })}
      </>
    );
  };
  const displayCustomerAdditionalFieldsList = (showAll = true) => {
    if (!showAll && !showCustomerAdditionalFields) {
      return;
    }
    if (showAll) {
      return (
        <>
          {customerAdditionalFields?.map((field, index) => (
            <li className="create-section-field-input">
              {field?.fieldName || '-'}
            </li>
          ))}
        </>
      );
    }
    return (
      <>
        {customerAdditionalFields?.map((field, index) => {
          if (customerProfileFields.length + index + 1 > 5) {
            return <></>;
          }
          return (
            <li className="create-section-field-input">
              {field?.fieldName || '-'}
            </li>
          );
        })}
      </>
    );
  };
  const displayAdditionalQuestion = (showAll = true) => {
    if (!showAll && !showAdditionalQuestion) {
      return;
    }
    if (showAll) {
      return (
        <>
          {additionalQuestion?.map((field, index) => (
            <li className="create-section-field-input">
              {field?.translations?.[LanguageConfig.english]?.fieldName || '-'}
              {diaplayOptitons(field)}
            </li>
          ))}
        </>
      );
    }
    return (
      <>
        {additionalQuestion?.map((field, index) => {
          if (
            customerProfileFields.length +
            customerAdditionalFields.length +
            index +
            1 >
            5
          ) {
            return <></>;
          }
          return (
            <li className="create-section-field-input">
              {field?.translations?.[LanguageConfig.english]?.fieldName || '-'}
              {diaplayOptitons(field)}
            </li>
          );
        })}
      </>
    );
  };

  const seeMorePromptContent = (
    <ul className="first-ul">
      {displayCustomerProfileFieldsList()}
      {displayCustomerAdditionalFieldsList()}
      {displayAdditionalQuestion()}
    </ul>
  );

  return (
    <>
      <CustomTitleLabel title={title} />
      <ul className="first-ul">
        {displayCustomerProfileFieldsList(false)}
        {displayCustomerAdditionalFieldsList(false)}
        {displayAdditionalQuestion(false)}
      </ul>
      {displayShowMoreButton && (
        <button
          type="button"
          className="btn-link create-section-field-input reset-button show-more-button"
          onClick={() => {
            setShowSeeMorePrompt(true);
          }}
        >
          show more
        </button>
      )}
      <AlertInfoPrompt
        show={showSeeMorePrompt}
        onCancel={() => setShowSeeMorePrompt(false)}
        onClose={() => setShowSeeMorePrompt(false)}
        onConfirm={() => setShowSeeMorePrompt(false)}
        title={title}
        content={seeMorePromptContent}
      />
    </>
  );
};

export default ProfileSection;
